module.exports = __webpack_public_path__ + "static/media/info.6b40ce39.svg";